module.exports = __webpack_public_path__ + "static/media/tutorial-01.f2e32255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial-01.jpg
// module id = 322
// module chunks = 0